{
  "title": "Choose your plan",
  "subtitle": "Upgrade anytime. Cancel anytime.",
  "upgrade": "Upgrade",
  "subscribe": "Subscribe",
  "currentPlan": "Current plan",
  "includedInPlan": "Included in your plan",
  "restore": "Restore purchases",
  "cancel": "Cancel subscription",
  "manage": "Manage subscription",
  "loading": "Loading plans…",
  "unavailable": "Plans are currently unavailable.",
  "saveBadge": "Save 20%",
  "topUp": {
    "title": "Top up credits",
    "subtitle": "Buy FYT credits to keep chatting with your AI Coach.",
    "balanceLabel": "Your balance",
    "balance": "{{amount}} credits",
    "balanceUnknown": "—",
    "pack": "Credit pack",
    "packCredits": "{{amount}} credits",
    "buy": "Buy",
    "unavailable": "Credit packs are currently unavailable."
  },
  "period": {
    "monthly": "Monthly",
    "yearly": "Yearly",
    "monthlyUnit": "per month",
    "yearlyUnit": "per year"
  },
  "plans": {
    "pro": {
      "name": "Pro",
      "tagline": "For serious tracking.",
      "features": {
        "barcodeScanning": "Barcode scanning for food",
        "customFoods": "Custom foods + serving units",
        "customExercises": "Custom exercises + muscle targets",
        "personalRecords": "Personal Records (top-3 medals)",
        "favorites": "Favorites for meals & exercises",
        "unlimitedHistory": "Unlimited history",
        "macroTargets": "Configurable macro & calorie targets",
        "restApi": "REST API access"
      }
    },
    "aiCoach": {
      "name": "AI Coach",
      "tagline": "Your smart assistant.",
      "features": {
        "mealChat": "Meal chat — search, log, update via conversation",
        "workoutChat": "Workout chat — build & modify workouts",
        "generalChat": "General chat + multi-step planner",
        "nutritionQa": "Personalized nutrition Q&A",
        "credits": "Metered by FYT credits (500/mo included)",
        "buyCredits": "Buy extra credits any time",
        "mcpAccess": "MCP server access"
      }
    }
  }
}
